import { User } from '@factorin/domain';

import { get, withUrl, patch } from '../rest';


interface ChangePasswordRequest {
    newpassword: string;
    oldpassword: string;
}

const profilePart = withUrl('profile');

export const profile = {
    userInfo: get<void, User.DFAProfile | User.CoProfile>(profilePart),

    changePassword: patch<ChangePasswordRequest, void>(
        ({ newpassword, oldpassword }) => profilePart({
            body: {
                newpassword,
                oldpassword,
            },
        }),
    ),

    roles: get<void, User.Profile['BusinessRoles']>(
        () => profilePart({
            path: 'roles',
        }),
    ),

    individualInfo: get<void, User.IndividualInfo>(
        () => profilePart({
            path: 'individual',
        }),
    ),
};
